export const en = {
  message: {
    layout: {
      login: 'Login',
      logout: 'Logout',
      customers: 'Customers',
      crm: 'CRM',
      dashboard: 'Dashboard',
      settings: 'Settings',
      timer: 'Time Management',
      user: 'Users',
      userRole: 'User Roles',
      productType: 'Product Types',
      priorities: 'Priorities',
      ticketStatus: 'Ticket Status',
      ticketTypes: 'Ticket Types',
      department: 'Departments',
      groups: 'Groups',
      ticket: 'Tickets',
      mailConfiguration: 'Mail Configuration',
      systemConfiguration: 'System Configuration',
      hse: 'HSE',
      product: 'Product',
      products: 'Products',
      order: 'Order',
      tools: 'Tools',
      deviation: 'Deviation',
      deviationCategory: 'Deviation Category',
      deviationLocation: 'Deviation Location',
      deviationStatus: 'Deviation Status',
      onedriveSetting: 'OneDrive Setting',
      sharepointSetting: 'Sharepoint Setting',
      sharepointCredential: 'Sharepoint Credential',
      clearOneDrive: 'Clear One Drive',
      category: 'Category',
      location: 'Location',
      priority: 'Priority',
      status: 'Status',
      deviations: 'Deviations',
      tickets: 'Tickets',
      types: 'Types',
      sharepoint: 'Sharepoint',
      crmSettings: 'CRM Settings',
      industries: 'Industries',
      shipments: 'Shipments',
      permission: 'Permissions',
      currencies: 'Currencies',
      salesAccounts: 'Sales Accounts',
      productGroup: 'Product groups',
      productUnit: 'Product unit',
      warehouseSettings: 'Warehouse settings',
      warehouse: 'Warehouse',
      warehouseLocations: 'Warehouse locations',
      offer: 'Offer',
      grossMargin: 'Gross margin',
      discountGroups: 'Discount groups',
      orderOrOffer: 'Offer/Order',
      productionOrder: 'Production Order',
      reports: 'Reports',
      workFlow: 'Product Workflow',
      WorkFlowStates: 'Workflow States',
      employees: 'Employees',
      returnForm: 'Return form',
      checklist: 'Checklist',
      checklists: 'Checklists'
    },
    login: {
      language: 'Language',
      back: 'Back',
      userName: 'Username',
      password: 'Password',
      authFailed: 'Authentication failed !',
      enterUserName: 'Enter User Name',
      enterPassword: 'Enter Password',
      enterConfirmPassword: 'Confirm Your Password',
      resetNow: 'Reset Now',
      invalidPassword: 'Invalid Password',
      unauthorizedMsg: 'You are not authorized',
      forgotPassword: 'Forgot password?',
      mailNotFound: 'Email not found',
      linkShared: 'Reset link has been successfully sent!',
      loginWithSharepoint: 'Login with Sharepoint'
    },
    common: {
      english: 'English',
      norwegian: 'Norwegian',
      save: 'Save',
      send: 'Send',
      edit: 'Edit',
      cancel: 'Cancel',
      update: 'Update',
      delete: 'Delete',
      updateAndClose: 'Update & Close',
      close: 'Close',
      new: 'New',
      isActive: 'Is active',
      addNew: 'Add new',
      action: 'Action',
      required_message: 'This field is required',
      savedSuccess: 'Saved successfully!',
      addedSucess: 'Added successfully !',
      updatedSuccess: 'Updated successfully !',
      uploadedSuccess: 'Uploaded successfully !',
      deleteSuccess: 'Deleted successfully !',
      backToList: 'Back To List',
      search: 'Search',
      yes: 'Yes',
      no: 'No',
      isDefault: 'Is Default',
      loadingMsg: 'Loading, Please wait',
      deleteConfirm: 'Delete Confirm',
      areYouSure: 'Are you sure you want to delete ?',
      validationIssue: 'Please check the required fields!',
      total: 'Total',
      noResults: 'No results found !',
      others: 'Others',
      typeHere: 'Type here...',
      position: 'Position',
      color: 'Color',
      maxCharacters: 'Max {charCount} characters',
      changedPassword: 'Password Changed Successfully',
      import: 'Import',
      note: 'Note',
      invalidEmail: 'Invalid Email',
      no_records: 'No Records Found!',
      ok: 'Ok',
      syncedSuccess: 'Synced Successfully',
      comments: 'Comments',
      export: 'Export',
      importProducts: 'Import Products',
      importSuppliers: 'Import Suppliers',
      exportProducts: 'Export Products',
      importSuccess: 'Imported successfully!',
      days: 'days',
      draft: 'Draft',
      sent: 'Sent',
      accepted: 'Accepted',
      notAccepted: 'Not accepted',
      ordered: 'Ordered',
      inProgress: 'In Progress',
      received: 'Received',
      receive: 'Receive',
      partiallyReceived: 'Partially Received',
      request: 'Request',
      partiallyPicked: 'Partially Picked',
      picked: 'Picked',
      normal: 'Normal',
      high: 'High',
      low: 'Low',
      medium: 'Medium',
      qtyExceeds: 'Qty Exceeds',
      difference: 'Difference',
      completedBy: 'Completed by',
      completedAt: 'Completed at',
      completed: 'Completed',
      complete: 'Complete',
      ccsheet_warehouse_exists: 'In complete sheets are available for this warehouse',
      batchExists: 'Batch number already exists!',
      actionPerformed: 'Action performed successfully !',
      receivedOn: 'Received on',
      add_extra_mails: 'NOTE: Please use comma(,) to add multiple email ids',
      copy_to_me: 'Copy to me',
      order_report: 'Order report',
      orderConfirm: 'Order confirmation',
      invalidDataFound: 'Invalid data found!',
      warning: 'Warning',
      changes_saved: 'You haven\'t saved your changes',
      are_you_navigate: 'Are you sure want to navigate ?',
      information: 'Information',
      both: 'Both',
      add: 'Add',
      actions: 'Actions',
      create: 'Create',
      validMessage: 'Must be Valid',
      action_sucess: 'Action performed successfully !',
      created_success: 'Created Successfully !',
      notFound: 'Not found!',
      select: 'Select',
      useEnterToAddMore: 'Use enter key to add more!',
      modifiedOn: 'Modified On',
      modifiedBy: 'Modified By',
      searchTriggerHint: '(Hit enter or click search icon)',
      confirmation: 'Confirmation',
      pickedqty: 'Pick qty'
    },
    dashboard: {
      new: 'New',
      orders: 'Orders',
      inProgress: 'In progress',
      cancelled: 'Cancelled',
      closed: 'Closed',
      day: 'Day',
      today: 'Today',
      monthly: 'Month',
      annual: 'Annual',
      noOfTickets: 'No. of Tickets',
      byDay: 'By day',
      byWeek: 'By week',
      byMonth: 'By month',
      byYear: 'By year',
      totalCustomers: 'Total Customers',
      totalOrders: 'Total Orders',
      totalHours: 'Total Hours',
      testWidget: 'Test Widget',
      topProduced: 'Top 5 produced',
      thisWeek: 'This week',
      lastWeek: 'Last week',
      thisMonth: 'This month',
      lastMonths: 'Last 3 months',
      boats: 'Boats',
      boatsProduced: 'Boats produced'
    },
    customer: {
      name: 'Name',
      address: 'Address',
      addressType: 'Type',
      country: 'Country',
      post: 'Post',
      city: 'City',
      municipality: 'Municipality',
      phone: 'Phone',
      email: 'Email',
      web: 'Web',
      description: 'Description',
      addCustomer: 'Add Customer',
      updateCustomer: 'Update Customer',
      contacts: 'Contacts',
      addContact: 'Add Contact',
      updateContact: 'Update Contact',
      telephone: 'Telephone',
      mobile: 'Mobilephone',
      jobTitle: 'Job title',
      addAddress: 'Add Address',
      updateAddress: 'Update Address',
      postbox: 'Post box',
      postCode: 'Post code',
      latitude: 'Latitude',
      longitude: 'Longitude',
      coordinates: 'Coordinates',
      isStandard: 'Is standard',
      receiveCertificate: 'Receive Certificate',
      customerOrSupplier: 'Customer/Supplier',
      activeOrInactive: 'Active/Inactive',
      active: 'Active',
      Inactive: 'Inactive',
      status: 'Status',
      priority: 'Priority',
      buyingCustomer: 'Buying customer',
      potentialCustomer: 'Potential customer',
      vat: 'VAT',
      vatValue: 'VAT',
      vatId: 'VAT',
      homepage: 'Homepage',
      visit: 'Visit',
      delivery: 'Delivery',
      invoice: 'Invoice',
      issupplier: 'Is Supplier',
      iscustomer: 'Is Customer',
      state: 'State',
      sg: 'SG',
      direct: 'Direct',
      ehf: 'EHF',
      pdf: 'PDF',
      paymentmethod: 'Payment Method',
      industry: 'Industry',
      shipment: 'Shipment',
      shipmentReport: 'Shipment',
      accountnumber: 'Account number',
      addSalesAccount: 'Add Sales account',
      updateSalesAccount: 'Update Sales account',
      norwegianLoc: 'Norwegian',
      foreign: 'Foreign',
      addons: 'Addons',
      noProductGroupsFound: 'No product groups found!',
      noOrdersFound: 'No orders found!',
      productGroup: 'Product group',
      notificationEmail: 'Notification e-mail',
      invoiceEmail: 'Invoice email',
      customerNumber: 'Customer number',
      exists: 'Customer exists in CRM',
      mainSupplier: 'Main supplier',
      secondarySupplier: 'Secondary supplier',
      priceList: 'Price list',
      current: 'Current',
      thisYear: 'This year',
      lastYear: 'Last year',
      sharepointConfigNotDone: 'Sharepoint config is not done'
    },
    user: {
      firstName: 'First name',
      lastName: 'Last name',
      addUser: 'Add User',
      updateUser: 'Update User',
      email: 'Email',
      mobile: 'Mobile',
      role: 'Role',
      pin: 'PIN',
      addRole: 'Add User Role',
      updateRole: 'Update User Role',
      profile: 'Profile',
      undo: 'Undo',
      clear: 'Clear',
      sendMailNotify: 'Like to get notification from ticketing system',
      group: 'Group',
      signature: 'Your signature',
      initial: 'Initial',
      employeeNumber: 'Employee number',
      certificateNumber: 'Certificate number'
    },
    warehouse: {
      stock: 'Stock',
      order: 'Order',
      ccsheet: 'CCSheet',
      product: 'Product',
      productName: 'Product name',
      addWarehouse: 'Add Warehouse',
      updateWarehouse: 'Update Warehouse',
      addLocation: 'Add Warehouse Location',
      updateLocation: 'Update Warehouse Location',
      warehouseSync: 'Sync to Shopbox & Opencart',
      openOrders: 'Open orders',
      addPackageOrContent: 'Would you like to add Package or its contents?',
      contents: 'Add contents',
      lowStockProposal: 'Low stock proposal',
      lowStockTitle: 'Low stock order proposal',
      warningAboutOrder: 'Would you like to create supplier order with selected rows?',
      createAndEmail: 'Create and email',
      createOnly: 'Create only',
      createOrder: 'Create order',
      ordersCreatedSuccess: 'Order(s) are created successfully!'
    },
    order: {
      orderdocuments: 'Order Documents',
      orderdetails: 'Order Details',
      customer: 'Customer',
      startDate: 'Start date',
      endDate: 'End date',
      hours: 'Hours',
      bas: 'Bas',
      manager: 'Manager',
      date: 'Date',
      deliveryDate: 'Delivery date',
      shippingDate: 'Delivery date',
      contactPerson: 'Contact person',
      updatedOn: 'Updated on',
      details: 'Details',
      lines: 'Lines',
      documents: 'Documnets',
      summary: 'Summary',
      orderName: 'Order Name',
      offerNumber: 'Offer Number',
      orderNumber: 'Order Number',
      statusName: 'Status Name',
      paymentTerm: 'Payment Terms',
      paymentDate: 'Payment Date',
      agentName: 'Agent Name',
      customerReference: 'Customer Reference',
      deliveryCondition: 'Delivery Condition',
      customerContactPerson: 'Customer Contact Person',
      deadlineDate: 'Deadline Date',
      notes: 'Notes',
      netprice: 'Net Price',
      estimatedhourscost: 'Estimated Hours Cost',
      estimatedtotalcosts: 'Estimated Total Costs',
      actualhourscost: 'Actual Hours Cost',
      actualtotalcosts: 'Actual Total costs',
      estimatedcontributionmargin: 'Estimated Contribution Margin',
      estimatedcontributionmarginratio: 'Estimated Contribution Margin Ratio',
      actualcontributionmargin: 'Actual Contribution Margin',
      actualcontributionmarginratio: 'Actual Contribution Margin Ratio',
      plannedhours: 'Planned Hours',
      plannedservedhours: 'Planned Served Hours',
      plannedprogress: 'Planned Progress',
      actualhours: 'Actual Hours',
      actualservedhours: 'Actual Served Hours',
      actualprogress: 'Actual Progress',
      noSummariesFound: 'No summeries found!',
      qty: 'Qty',
      height: 'Height',
      customername: 'Customer Name',
      unitprice: 'Unit Price',
      measureunit: 'Measure Unit',
      totalnetprice: 'Total Net Price',
      totalprice: ' Total Price',
      actualplandate: 'Actual Plan Date',
      actualstartdate: 'Actual Start Date',
      actualenddate: 'Actual End Date',
      certificate: 'Certificate',
      supplier: 'Supplier',
      batchNumber: 'Batch Number',
      article: 'Article',
      download: 'Download',
      share: 'Share',
      emailNote: 'Please use comma(,) to add multiple email ids',
      searchByBatchNumber: 'Search by Batch number',
      showOrderRequire: 'Show orders require cert',
      recreateCertificate: 'Recreate Certificate',
      syncNow: 'Sync Now',
      sendToCustomer: 'Send to customer',
      sendToDefined: 'Send to defined',
      batchNo: 'Batch no.',
      myOrder: 'My orders',
      order: 'Order',
      deliveredQty: 'Delivered',
      unableToDelete: 'Unable to delete!',
      orderBillingData: 'Order / Billing data',
      orderOffer: 'Offer/Order',
      myTasks: 'My tasks',
      offerAccepted: 'Offer is accepted and new order will be created. Do you want to continue?',
      orderedQtyHigh: 'Qty received is higher than ordered, would you like to proceed?',
      paymentTerms: 'Payment terms',
      salesOrder: 'Sales order',
      asMainSupplier: 'As main supplier',
      searchLocation: 'Search Location',
      rest: 'Rest',
      newProdOrder: 'New prod. order'
    },
    document: {
      title: 'Document',
      codename: 'Code Name',
      datecreated: 'Created at',
      documentnumber: 'Number',
      text: 'Text',
      cost: 'Cost',
      statusdate: 'Status Date',
      versionHistory: 'Version History',
      versioningDocuments: 'Versioning Documents',
      versionLabel: 'Version Label',
      size: 'Size'
    },
    product: {
      addProduct: 'Add Product',
      updateProduct: 'Update Product',
      number: 'Number',
      shortName: 'Short name',
      unit: 'Unit',
      length: 'Length (m)',
      width: 'Width (m)',
      thickness: 'Thickness (m)',
      weight: 'Weight (kg)',
      certificateReq: 'Certificate required',
      type: 'Type',
      image: 'Image',
      ignoreDiscount: 'Ignore discount',
      measureUnit: 'Measure unit',
      radius: 'Radius (mm)',
      minLength: 'Min length (m)',
      minWidth: 'Min width (m)',
      minHeight: 'Min height',
      minThickness: 'Min thickness (m)',
      maxLength: 'Max length (m)',
      maxWidth: 'Max width (m)',
      maxHeight: 'Max height',
      maxThickness: 'Max thickness (m)',
      area: 'Area',
      supplierName: 'Supplier name',
      articleNumber: 'Article number',
      articleName: 'Article name',
      isStockItem: 'Stock item',
      isInventoryItem: 'Inventory item',
      grossMargin: 'Gross margin %',
      minStock: 'Min stock',
      maxstockqty: 'Max stock qty',
      restockqty: 'Restock qty',
      deliveryDays: 'Delivery days',
      deleteImage: 'Delete Image',
      addProductGroup: 'Add Product Group',
      updateProductGroup: 'Update Product Group',
      costs: 'Costs',
      taskName: 'Task name',
      hours: 'Hours',
      netCostPrice: 'Net cost price',
      additionalCostPer: 'Additional cost percentage',
      currencyExchange: 'Currency exchange rate',
      costPrice: 'Cost price',
      salePrice: 'Sale price',
      addSupplierItem: 'Add supplier item',
      updateSupplierItem: 'Update supplier item',
      discount: 'Discount',
      addBatchNumber: 'Add batch number',
      updateBatchNumber: 'Update batch number',
      work: 'Work',
      prices: 'Prices',
      priceValidFrom: 'Price valid from',
      salesAccount: 'Sales account',
      stocks: 'Stocks',
      available: 'Available',
      orderQty: 'Order qty',
      measures: 'Measures',
      suppliers: 'Suppliers',
      supplierPrice: 'Supplier price',
      supplierDiscount: 'Supplier discount%',
      discounted: 'Discounted',
      shipmentAddon: 'Shipment addon%',
      other: 'Other %',
      currency: 'Currency',
      realCost: 'Real cost',
      realCostNOK: 'Real cost (NOK)',
      isMain: 'Is Main',
      isPackage: 'Is Package',
      packageProducts: 'Package products',
      shipment: 'Shipment %',
      other_per: 'Other %',
      batchRequired: 'B.No?',
      batchOrWIN: 'Batch/WIN',
      barcode: 'Barcode',
      attachments: 'Attachments',
      file: 'File',
      chooseFile: 'Choose file',
      batches: 'Batches',
      batchNumber: 'Batch number',
      printLbl: 'Print label',
      reportIsReady: 'Report generation is under progress, it will be sent in mail when it is ready',
      selectPreferredSize: 'Select Preferred Size',
      print: 'Print',
      exportMsg: 'The export file is being genereated, it will be sent to your mail when ready',
      supplierNo: 'Supplier nbr',
      priceHistory: 'Price history',
      salesPrice: 'Sales Price',
      wayOfUpdate: 'Way of update',
      basePrice: 'Base price',
      priceAdj: 'Price adj.',
      adjustByIn: 'Adjust by in %',
      dateFrom: 'Date from',
      priceAdjustments: 'Price adjustments',
      by_direct_update: 'By direct',
      by_mass_adjust: 'By mass adjustment',
      by_import: 'By import',
      priceAdjustmentAdded: 'The price history is added, and will take effect from respective date',
      salePriceExVat: 'Sales price ex vat',
      salePriceIncVat: 'Sales price incl vat',
      exportAllData: 'Export all data',
      importAllData: 'Import all data',
      exportSupplierPrices: 'Export supplier prices',
      importSupplierPrices: 'Import supplier prices',
      supplierPriceAdjustment: 'Supplier price adjustment',
      leadTime: 'Lead time (days)',
      copyWin: 'Copy WIN',
      qty: 'Qty',
      minQty: 'Min Qty',
      addAtleastOneUnit: 'Add atleast one unit',
      salesUnit: 'Sales unit',
      supplier: 'Supplier',
      ean: 'EAN',
      package: 'Package'
    },
    priority: {
      addPriority: 'Add Priority',
      updatePriority: 'Update Priority'
    },
    project: {
      detail_page: {
        en_name: 'English Name',
        no_name: 'Norwegian Name'
      }
    },
    ticketStatus: {
      addTicketStatus: 'Add Ticket Status',
      updateTicketStatus: 'Update Ticket Status',
      canClose: 'Can close'
    },
    group: {
      addGroup: 'Add Group',
      updateGroup: 'Update Group'
    },
    tickets: {
      createTicket: 'Create Ticket',
      updateTicket: 'Update Ticket',
      createType: 'Create Type',
      updateType: 'Update Type',
      merge: 'Merge',
      ticketMerge: 'Tickets Merge',
      chooseParentTicket: 'Choose Parent Ticket',
      changeStatus: 'Change Status',
      changePriority: 'Change Priority',
      changeAssignedTo: 'Change Assigned To',
      assignTo: 'Assign To',
      delete: 'Delete',
      mailbox: 'MailBox',
      assignedTo: 'Assigned To',
      unread: 'Unread',
      number: 'Number',
      status: 'Status',
      type: 'Type',
      tags: 'Tags',
      priority: 'Priority',
      from: 'From',
      subject: 'Subject',
      createdOn: 'Created On',
      to: 'To',
      cc: 'Cc',
      bcc: 'Bcc',
      deleteConfirm: 'Are you sure you want to delete these tickets ?',
      deleteNote: 'Choosing this option will delete mails permanently',
      selectTickets: 'Select tickets',
      sentSuccess: 'Mail sent!',
      mergeSuccess: 'Merged Successfully',
      body: 'Body',
      note: 'Note',
      deleteMailsTo: 'Delete mails too?',
      all: 'All',
      notAssigned: 'Not Assigned'
    },
    mailConfiguration: {
      name: 'Name',
      host: 'Host',
      port: 'Port',
      usessl: 'UseSsl',
      username: 'UserName',
      password: 'Password',
      dosync: 'DoSync',
      syncfrom: 'Sync date',
      synctime: 'Sync time',
      lastsynced: 'Last Synced',
      signature: 'Mail Signature',
      addMailConfig: 'Add Mail Configuration',
      updateMailConfig: 'Update Mail Configuration',
      testConnection: 'Test Connection',
      connectionSuccess: 'Connection successful!',
      connectionFail: 'Connection failed!',
      action: 'Action'
    },
    systemConfiguration: {
      ticketterm: 'Ticket Term',
      enableawb: 'Enable #AWB',
      syncinterval: 'Sync Interval (in minutes)',
      systemConfig: 'Ticketing Configuration',
      ticketCreation: 'Ticket creation response'
    },
    deviations: {
      title: 'Title',
      location: 'Location',
      category: 'Category',
      estimate_cost: 'Estimate Cost',
      severity: 'Severity',
      addDeviation: 'Add Deviation',
      updateDeviation: 'Update Deviation',
      reported_by: 'Reported By',
      reason: 'Reason',
      underlying_reason: 'Underlying Reason',
      corrective_actions: 'Corrective Actions',
      effective_of_measures: 'Effect of Measures',
      responsible: 'Responsible',
      copy_to: 'Copy To',
      created_on: 'Created on',
      deadline: 'Deadline',
      deviationcategories: 'Deviation Categories',
      locationtype: 'Location Type',
      printChart: 'Print chart',
      downloadPNG: 'Download PNG',
      downloadJPEG: 'Download JPEG',
      downloadPDF: 'Download PDF',
      downloadSVG: 'Download SVG',
      statistics: 'Statistics',
      deviation_report: 'Deviation Report',
      retrunFormSubmit: 'Form successfully submitted. You will be contacted by Rotostøp'
    },
    severity: {
      select: 'Select severity',
      low: 'Low',
      medium: 'Medium',
      high: 'High'
    },
    hse: {
      hseSystem: 'HSE-SYSTEM',
      uploadDocument: 'Upload Document',
      gettingFolders: 'Getting Folders From SharePoint.... Please wait...',
      noDocuments: 'NO DOCUMENTS FOUND!',
      noFolders: 'NO FOLDERS FOUND!',
      createNew: 'Create folder',
      editName: 'Edit folder',
      deleteFolder: 'Delete folder',
      upload: 'Upload',
      folderName: 'Folder name',
      files: 'Files',
      noResponsible: '*no responsible',
      noDescription: '*no description',
      updateMetaData: 'Update Meta Data',
      openNewTab: 'Open in new Tab',
      editMeta: 'Edit Meta'
    },
    deviationSettings: {
      addCategory: 'Add Deviation Category',
      updateCategory: 'Update Deviation Category',
      addStatus: 'Add Deviation Status',
      updateStatus: 'Update Deviation Status',
      addLocation: 'Add Deviation Location',
      updateLocation: 'Update Deviation Location'
    },
    datestrings: {
      year: 'Year',
      today: 'Today',
      month: 'Month'
    },
    onedriveSettings: {
      oneDriveSetup: 'Configure the base folders for HSE and Products.',
      selectHse: 'Select HSE base',
      selectProduct: 'Select Product base',
      selectCustomer: 'Select Customer base',
      odLink: 'Onedrive Link'
    },
    sharepointSettings: {
      baseUrl: 'Base url',
      siteUrl: 'Site url',
      listName: 'List name',
      loadFolders: 'Load folders',
      loadList: 'Load List',
      propertiesConfig: 'Properties Configuration',
      contentType: 'Content Type'
    },
    sharePoint: {
      config: 'SharePoint Configurations',
      rootFolder: 'Root Folder'
    },
    shipment: {
      addShipment: 'Add shipment',
      updateShipment: 'Update Shipment',
      bring: 'Bring',
      tnt: 'TNT',
      postnord: 'Postnord'
    },
    industry: {
      addIndustry: 'Add industry',
      updateIndustry: 'Update industry'
    },
    permissions: {
      manageShifts: 'Manage shift',
      manageOpencartOrders: 'Manage opencart order',
      manageShopboxOrders: 'Manage shopbox order',
      manageSettings: 'Manage settings'
    },
    currency: {
      addCurrency: 'Add currency',
      updateCurrency: 'Update currency',
      exchangeRate: 'Exchange Rate',
      validFrom: 'Valid From',
      currencyHistories: 'Currency histories'
    },
    unit: {
      addUnit: 'Add product unit',
      updateUnit: 'Update product unit'
    },
    whOrder: {
      orderedQty: 'Ordered Qty',
      unitCost: 'Unit Cost',
      supplierOrder: 'Supplier order',
      adjustmentOrder: 'Adjustment order',
      returnOrder: 'Return order',
      transferOrder: 'Transfer order',
      addSupplierOrder: 'Add Supplier Order',
      updateSupplierOrder: 'Update Supplier Order',
      addAdjustmentOrder: 'Add Adjustment Order',
      updateAdjustmentOrder: 'Update Adjustment Order',
      addReturnOrder: 'Add Return Order',
      updateReturnOrder: 'Update Return Order',
      addTransferOrder: 'Add Transfer Order',
      updateTransferOrder: 'Update Transfer Order',
      orderType: 'Ordertype',
      from: 'From',
      to: 'To',
      orderDate: 'Order date',
      estimated: 'Estimated',
      pickFiles: 'Choose files',
      orderQty: 'Order qty',
      recQty: 'Rec.qty',
      productNotAvailbleMsg: 'Selected product not available in the location!',
      onstockLessMsg: 'Qty should not be less than stock!',
      sameProductMsg: 'Select Different product',
      minQty: 'Min. qty',
      availQty: 'Avail.qty',
      sourceWH: 'Source whs',
      destinationWH: 'Destination whs',
      pickQty: 'Picked. qty',
      loc: 'Loc',
      ordQty: 'Ord.qty',
      batch: 'Batch',
      noLoc: 'No Loc.',
      orderProposal: 'Order proposal',
      orderedQtyLessMsg: 'Picked qty cannot be higher than ordered!',
      reserved: 'Reserved',
      estimateDelivery: 'Estimate/Delivery date',
      allData: 'All data',
      supplierPrices: 'Supplier prices',
      expireDate: 'Expiry date',
      receiveAll: 'Receive all'
    },
    stock: {
      onStock: 'On Stock',
      onOrder: 'On Order',
      location: 'Location',
      costPrice: 'Cost Price',
      onCustomerOrder: 'On Customer Order',
      batchOrWin: 'Batch/WIN',
      winOrProduct: 'WIN/product'
    },
    ccsheet: {
      addCCSheet: 'Add CCSheet',
      updateCCSheet: 'Update CCSheet',
      ongoing: 'On going',
      onStock: 'On stock',
      counted: 'Counted',
      recount: 'Recount',
      completed: 'Completed',
      completedAndAdjusted: 'Completed and adjusted',
      useScanner: 'Use Scanner',
      noProductsFound: 'No Products found',
      proceed: 'Proceed',
      scannerLocation: 'Scan / Search by location',
      searchLocation: 'Filter by location',
      scanProduct: 'Scanning Product',
      ccsheetReport: 'CCSheet',
      completeSheet: 'Would you really like to close current stock count?',
      countedTotal: 'Counted Total',
      totalValues: 'Total values',
      diff: 'Diff'
    },
    orders: {
      addOrder: 'Add Order',
      updateOrder: 'Update Order',
      contact: 'Contact',
      deliveryAddress: 'Delivery address',
      invoiceAddress: 'Invoice address',
      invoiceTo: 'Invoice to',
      ourReference: 'Our reference',
      yourReference: 'Your reference',
      offerInformation: 'Order Information',
      offerComments: 'Offer text and comments',
      standardSales: 'Standard Sales',
      deliveryTerms: 'Delivery Terms',
      totalExVat: 'Total Ex VAT',
      totalSum: 'Total Sum',
      productNo: 'Product No.',
      price: 'Price',
      dataSheet: 'Datasheet',
      searchForProduct: 'Search for product...',
      offerDate: 'Offer date',
      offerDueDate: 'Offer due date',
      orderDate: 'Order date',
      deliveryDate: 'Delivery date',
      forProduction: 'For production',
      forApproval: 'For approval',
      toInvoice: 'To invoice',
      invoiced: 'Invoiced',
      cancelled: 'Cancelled',
      orderDetails: 'Order Details',
      materials: 'Materials',
      billingData: 'Billing Data',
      approve: 'Approve',
      addNew: 'Add New',
      pQty: 'P.Qty',
      user: 'User',
      invoiceQty: 'Invoice Qty',
      addNewProduct: 'Add New Product',
      history: 'History',
      createdBy: 'Created by',
      updatedBy: 'Updated by',
      lastUpdated: 'Last updated',
      billingTotalExVat: 'Billing total ex VAT',
      offerPart: 'Offer part',
      orderComments: 'Order text and comments',
      stockAvailable: 'Stock available',
      planned: 'Planned',
      toBeShipped: 'To be shipped',
      shipped: 'Shipped',
      closed: 'Closed',
      restQty: 'Rest qty',
      contents: 'Contents',
      packList: 'Packing list',
      sureToCreateOrder: 'Proceed to create production order?',
      deleted: 'Deleted',
      customerOrder: 'Customer/Supplier'
    },
    discountGrp: {
      customerGroup: 'Customer groups'
    },
    productionOrder: {
      createProduction: 'Create Production Order',
      updateProduction: 'Update Production Order',
      archived: 'Archived',
      byProduct: 'By Product',
      win: 'WIN',
      winNumbers: 'WIN Numbers',
      bProduct: 'B-product',
      wishToContinue: 'The product will be marked as B-product. Only admin user can change the status. Comment is mandatory. Do you want to continue?',
      inProduction: 'In production',
      nr: 'Nr.',
      started: 'Started',
      orderStatus: 'Order status',
      productStatus: 'Product status',
      volume: 'Volume',
      produced: 'Produced',
      finished: 'Finished',
      rest: 'Rest',
      extradit: 'Extradit',
      plan_measures: 'Plan measures',
      forging_measures: 'Forging measures',
      order_measures: 'Order measures',
      plan_weight: 'Plan weight',
      forging_weight: 'Forging weight',
      weightForPresse: 'Vekt for presse',
      qtyStampedOut: 'Ant.presset',
      finalWeight: 'Ferdigvekt',
      restVolume: 'Avgang',
      weightPerPiece: 'Vekt per stykk',
      productionStatus: 'Production status', // copying fully from arven from nextline
      orderType: 'Order Type',
      startDate: 'Start Date',
      endDate: 'End Date',
      deliveryDate: 'Delivery',
      startedDate: 'Started',
      number: 'Number',
      supWhs: 'Supplier/Whs',
      from: 'From',
      to: 'To',
      addorder: 'Add Order',
      quantity: 'Antall',
      orderedqty: 'Ordered',
      producedqty: 'Produced',
      makingqty: 'In prod.',
      backorderqty: 'Backorder',
      createOrder: 'Create Order',
      createProdOrder: 'Create production order',
      editOrder: 'Edit Order',
      addPackage: 'Add Package',
      orderstatus: 'Status',
      updateOrder: 'Update Order',
      department: 'Department',
      administration: 'Administration',
      salgorService: 'Salg/service',
      showAll: 'Show All',
      myOrder: 'My order',
      myDepartment: 'My department',
      assignedToMe: 'Assigned to me',
      normal: 'Normal',
      high: 'High',
      low: 'Low',
      draft: 'Draft',
      showonlyZero: 'Show Only Zero',
      draftState: 'New',
      newState: 'New',
      inProgress: 'In Progress',
      completedState: 'Completed',
      received: 'Received',
      element: 'Elements',
      startedProduct: 'Started Products',
      notStartedProduct: 'Not Started Products',
      newProducts: 'New Products',
      startProduction: 'Start Production',
      quantity_exceeds: 'Quantiy Exceeds',
      production_status: 'Production Status',
      date_valid: 'Date validation failed !',
      view_history: 'View History',
      no_history_found: 'No history found for this record',
      history_products: 'History On Products',
      no_quantity_found: 'No quantity found in In_Production !',
      prod_status: 'Prod Status',
      returned_to_stock: 'Returned to stock',
      taken_from_stock: 'Taken from stock',
      split_production_row: 'Split production row',
      current_value: 'Current value for {product} is {count}',
      enter_value_to_split: 'Enter value to split by :',
      qty_exceeds: 'Quantity exceeds !',
      startProductionOf: 'Start Production Of',
      takeOut: 'Take out',
      completeProduction: 'Complete Production',
      rawMaterials: 'Raw materials',
      newProductionStatus: 'New production status',
      productExists: 'Product alreadt exists!',
      waste: 'Waste',
      checkAvailability: 'Check availability',
      requiredQty: 'Required Qty',
      availableQty: 'Available Qty',
      bom: 'BOM',
      productionHistory: 'Production history WIN'
    },
    settings: {
      add_department: 'Add Department',
      update_department: 'Update Department',
      add_product_classes: 'Add Product Class',
      update_product_classes: 'Update Product Class',
      add_workflow: 'Add Workflow',
      update_workflow: 'Update Workflow',
      add_workflowStates: 'Add Workflow States',
      update_workflowStates: 'Update Workflow States',
      selected_workflowList: 'Selected Workflow States',
      available_workflowList: 'Available Workflow States',
      generateWin: 'Generate WIN',
      prefixForwin: 'Prefix for WIN',
      is_generate_win: 'Is Generate Win',
      wishToContinue: 'If year is changed, the WIN will be generated with that model. Do you wish to continue?',
      changeConfirm: 'Confirm Change?',
      add_tools: 'Add Tools',
      update_tools: 'Update Tools',
      rack_name: 'Rack name',
      shelf_name: 'Shelf name',
      planning: 'Planning',
      pressing: 'Stamp out',
      grinding: 'Grinding',
      silvering: 'Silvering',
      polishing: 'Polishing',
      packing: 'Packing',
      states: 'States',
      molding: 'Molding',
      bladeRetaining: 'Blade Retaining',
      soldering: 'Soldering',
      pick_color: 'Pick Color',
      standardInvoiceText: 'Standard invoice text'
    },
    stocks: {
      productNumber: 'Product Number',
      desc: 'Description',
      onStock: 'On Stock',
      onOrder: 'On Order',
      productionOrder: 'Production Order',
      location: 'Location',
      orderNumber: 'Order Number',
      sn: 'sn',
      department: 'Department',
      show: 'Show',
      nr: 'Nr.',
      customer: 'Customer',
      req: 'Req./Project',
      equipment: 'Equipment',
      ordered: 'Ordered',
      delivery: 'Delivery',
      category: 'Category',
      po: 'PO',
      startDate: 'Start Date',
      endDate: 'End Date',
      deliveryDate: 'Delivery Date',
      quantity: 'Quantity',
      history: 'History',
      import: 'Import',
      export: 'Export',
      importStock: 'Import Stock',
      importProduct: 'Import Product',
      time: 'Time'
    },
    report: {
      filter_action: 'Filter Actions',
      select_type: 'Select Type',
      select_report: 'Select report',
      per_project: 'Per Project',
      per_customer: 'Per Customer',
      per_activity: 'Per Activity',
      show_only_sum: 'Show Only Sum',
      show_estimation: 'Show Estimation',
      filter: 'Run report',
      empty_filter: 'Nothing to show at this moment !',
      add_extra_mails: 'NOTE: Please use comma(,) to add multiple email ids',
      send_report: 'Send Report',
      only_pdf: 'Only PDF',
      only_xlsx: 'Only XLSX',
      both: 'Both',
      time_management_report: 'Timer report',
      select_hours_status: 'Select Hours Status',
      estimation: 'Estimation',
      progress: 'Progress',
      file_type: 'File type',
      progress_total: 'Progress Total',
      sent_success: 'Sent successfully',
      standard: 'Standard',
      absence: 'Absence',
      email_order_details: 'Email order details',
      copy_to_me: 'Copy to me',
      order_report: 'Order report',
      producedProductWeight: 'Produced Products Weight',
      stockOverview: 'Stock overview',
      showZeroProduct: 'Show 0 product',
      timePeriodStart: 'Time period from',
      timePeriodEnd: 'Time period to',
      productGroup: 'Product Group',
      productNumber: 'Product Number',
      productName: 'Product Name',
      date: 'Date',
      qty: 'Qty',
      standardWeight: 'Std Weight',
      stdWeightTotal: 'Std Weight Total',
      checkedWeight: 'Checked Weight',
      productClass: 'Product class',
      onStock: 'On stock',
      bookedValue: 'Booked value',
      materialDemand: 'Materials demand',
      from: 'From',
      to: 'To',
      report: 'Report',
      productUsage: 'Product usage',
      productionReport: 'Daily production report',
      dateTimeStart: 'Date and time start',
      dateTimeEnd: 'Date and time completed',
      bQty: 'B Qty',
      usedQty: 'Used Qty',
      usedBy: 'Used By',
      usedDate: 'Used Date',
      inventoryReport: 'Inventory report',
      totalInventoryValue: 'Total Inventory value',
      locations: 'Locations',
      vendor: 'Vendor',
      totalInventory: 'Total Inventory',
      prodNo: 'Prod.nr'
    },
    products: {
      number: 'Number',
      name: 'Product name',
      addProduct: 'Add product',
      updateProduct: 'Update Product',
      elementNumber: 'Elementnummer',
      element_name: 'Element Name',
      costPrice: 'Cost price',
      buyerTax: 'Tax %',
      salePrice: 'Sale price',
      listPrice: 'List Price',
      accountNo: 'Account No',
      currency: 'Currency',
      tax: 'Tax',
      unit: 'Unit',
      discount: 'Discount',
      supp: 'Supp.prodnbr',
      length: 'Length',
      netWeight: 'Net weight',
      width: 'Width',
      height: 'Height',
      suppNumber: 'Supplier Number',
      addPackage: 'Add package',
      editPackage: 'Edit package',
      updatePackage: 'Update package',
      cement: 'Betong',
      cementQuality: 'Betong kvalitet',
      type: 'Type',
      group: 'Product group',
      thickness: 'Thickness',
      copy_confirm_head: 'Copy Confirmation !',
      copy_confirm_msg: 'Do you want to create a copy?',
      multiple: 'Multiple',
      deliveryTime: 'Delivery Time',
      decimals: 'Decimals',
      operation_type: 'Operation Type',
      new_fields: 'Extra info',
      plan_measures: 'Plan measures',
      forging_measures: 'Forging measures',
      order_measures: 'Order measures',
      plan_weight: 'Plan weight',
      forging_weight: 'Forging weight',
      showActive: 'Show Only Active',
      returnProductTitle: 'Raw material take out and return',
      retQty: 'Ret.qty',
      return: 'Return',
      statusChangeWarn: 'Status for one or more products has been changed. The stock of used materials will be adjusted. Do you wish to proceed ?',
      updateConfirm: 'Update Confirmation',
      standard_weight: 'Standard Weight',
      stampOutChange: 'Return product to change status',
      errorWorkflow: 'Select product workflow',
      syncTripletex: 'Sync from Tripletex',
      syncStarted: 'Syncing will automatically on background, Please wait!',
      tripletexUser: 'Tripletex user',
      copyAsNew: 'Copy as new product',
      copyOnlyContents: 'Copy on the contents',
      copyTo: 'Copy to',
      copyToValidation: 'Copy to field should not be empty!'
    },
    users: {
      active: 'Active'
    },
    crm: {
      name: 'Name'
    },
    invoice: {
      saveAs: 'Save As',
      saveAsDraft: 'Save as Draft',
      saveAndEmail: 'Save and Email',
      saveAndDownloadPDF: 'Save and download PDF',
      saveAndUseEHF: 'Save and use EHF (Auto invoice)'
    },
    userRole: {
      administrator: 'Administrator',
      office: 'Office',
      technician: 'Technician',
      technicians: 'Technicians'
    },
    returnForm: {
      companyName: 'Company / Name',
      companyNo: 'Company No',
      add: 'Add form record',
      update: 'Update form record'
    },
    props: {
      new: 'New',
      name: 'Name',
      description: 'Description',
      label: 'Label',
      type: 'Type',
      placeholder: 'Placeholder',
      isActive: 'Is Active',
      actions: 'Actions',
      value: 'Value',
      properties: 'properties',
      options: 'Options',
      addProps: 'Add Properties',
      updateProps: 'Update Properties',
      formAttributes: 'FORM ATTRIBUTES',
      useAsTitle: 'Use as title',
      validation: 'Validation',
      isMultiSelect: 'Is multiselect',
      defaultValue: 'Default Value',
      enterValue: 'Enter one of the values from option',
      isApi: 'Is API',
      apiUrl: 'API URL',
      objectName: 'Object name',
      columns: 'Columns',
      gridColumns: 'Grid Columns',
      question: 'Question ?',
      link: 'Html',
      enterTitleOfColumn: 'Enter Title Of Each Columns',
      loadingGrid: 'Loading grids...',
      favourite: 'Favourite',
      customProperties: 'Custom Properties',
      enterTitle: 'Enter Title',
      rows: 'Rows',
      preparingFields: 'Preparing Fields',
      dragging: 'Dragging...',
      fontSize: 'Font size',
      preview: 'Preview',
      hideComments: 'Hide Comments',
      hideAttachments: 'Hide Attachments',
      defaultValueKeyword: 'Default Value by keyword',
      setCurrentUserAsDefault: 'Set current user as default',
      rowsToAutoCreate: 'Rows to auto create on checklist create',
      showInNextRow: 'Show in next row',
      addTopSpace: 'Add top space',
      optionsValuesAreNotUnique: 'Options list values are not unique',
      viewType: 'View type',
      showWidthField: 'Show width field above header',
      enterTitleAndWidthOfColumn: 'Enter title and width of the column',
      fieldInfo: 'Field info',
      valueForCalculation: 'Value for calculation',
      customFieldsNotAvailable: 'Custom field not available',
      selectStatus: 'Select status',
      template: 'Template',
      drag: 'Drag',
      showSum: 'Show sum'
    },
    form: {
      updateFormProps: 'Update Form Properties',
      addNewForm: 'Add new form',
      selectGroup: 'Select group',
      addHeader: 'Add Header',
      addFooter: 'Add Footer',
      formProps: 'FORM PROPERTIES',
      allCaughtUp: 'All caught up!',
      dropFields: 'Drop the fields here!',
      addHtmlContent: 'ADD HTML CONTENT',
      forHeader: 'FOR HEADER',
      forFooter: 'FOR FOOTER',
      comments: 'Comments',
      attachments: 'Attachments',
      sureToCloneFields: 'Are you sure want to clone fields?',
      documents: 'Documents',
      document: 'Document',
      updateDocument: 'Update Document',
      addGroup: 'Add Group',
      updateGroup: 'Update Group',
      date: 'Date',
      signature: 'Signature'
    },
    checklist: {
      addChecklist: 'Add checklist',
      updateChecklist: 'Update checklist'
    }
  }
}
